var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallHistoryRecoveryCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.667,
    height: 16,
    viewBox: "0 0 18.667 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-history",
    d: "M10.667 0a8 8 0 0 0-8 8H0l3.458 3.458.062.124L7.111 8H4.444a6.252 6.252 0 1 1 1.831 4.391l-1.262 1.262A8 8 0 1 0 10.667 0zm-.889 4.444v4.444l3.8 2.258.64-1.076-3.111-1.849V4.444z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallHistoryRecoveryCall);
export default __webpack_public_path__ + "static/media/callHistoryRecoveryCall.d0973bc30f15620e6b40bf540bea193c.svg";
export { ForwardRef as ReactComponent };